import { render, staticRenderFns } from "./PublicKnowledgeBaseTab.vue?vue&type=template&id=7a331dba&scoped=true&"
import script from "./PublicKnowledgeBaseTab.vue?vue&type=script&lang=js&"
export * from "./PublicKnowledgeBaseTab.vue?vue&type=script&lang=js&"
import style0 from "./PublicKnowledgeBaseTab.vue?vue&type=style&index=0&id=7a331dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a331dba",
  null
  
)

export default component.exports